// window.dataLayer 로의 유일한 창구.
//
// react-gtm-module 을 대체한다. 그 라이브러리에서 실제로 쓰던 것은 initialize() 1회와
// dataLayer() 2회뿐이었고, initialize 는 _document 의 정적 스니펫으로 옮겼다.
//
// dataLayer 는 그냥 배열이다. GTM 컨테이너가 로드되지 않은 환경(로컬 개발)에서도
// push 는 배열에 쌓이기만 하고 아무 부작용이 없다. 그래서 호출부에 환경 게이트를 두지 않는다 —
// 개발자가 로컬에서 window.dataLayer 를 열어 페이로드를 그대로 검증할 수 있다.

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export interface DataLayerEvent extends Record<string, unknown> {
  event: string;
}

export function pushToDataLayer(payload: DataLayerEvent): void {
  if (typeof window === "undefined") {
    return;
  }
  const dataLayer = (window.dataLayer = window.dataLayer ?? []);
  dataLayer.push(payload);
}
